import { render } from "./static-dialog.vue?vue&type=template&id=6c5ed4e0"
import script from "./static-dialog.vue?vue&type=script&lang=js"
export * from "./static-dialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__